export default function SocialMediaSection() {
  const socialLinks = [
    {
      name: 'Instagram',
      icon: 'https://tristatewarriors.com/wp-content/uploads/2024/03/INSTA.png',
      url: 'https://www.instagram.com/tri_warriors',
      color: 'from-purple-600 to-pink-600',
    },
    {
      name: 'Facebook',
      icon: 'https://tristatewarriors.com/wp-content/uploads/2024/03/FACEBOOK.webp',
      url: 'https://www.facebook.com/3StateWarriors/',
      color: 'from-blue-600 to-blue-700',
    },
    {
      name: 'X (Twitter)',
      icon: 'https://tristatewarriors.com/wp-content/uploads/2024/03/X-LOGO.png',
      url: 'https://x.com/tri_warriors',
      color: 'from-gray-800 to-black',
    },
    {
      name: 'YouTube',
      icon: 'https://tristatewarriors.com/wp-content/uploads/2024/03/YOUTUBE-LOGO.png',
      url: 'https://www.youtube.com/@tri-statewarriors2950',
      color: 'from-red-600 to-red-700',
    },
  ];

  return (
    <div className="py-24 bg-gradient-to-br from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-white mb-4">
            Follow The Warriors
          </h2>
          <p className="text-lg text-gray-300">
            Stay connected and never miss a moment
          </p>
        </div>

        {/* Social Media Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-white rounded-2xl p-8 hover:scale-105 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${social.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
              <div className="relative flex flex-col items-center">
                <div className="w-24 h-24 mb-4 flex items-center justify-center">
                  <img
                    src={social.icon}
                    alt={social.name}
                    className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <h3 className="text-base font-bold text-gray-900 text-center">
                  {social.name}
                </h3>
              </div>
            </a>
          ))}
        </div>

        {/* Additional CTA */}
        <div className="text-center mt-16">
          <p className="text-white text-lg mb-6">
            Join our community and be part of the Warriors family
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#newsletter"
              className="inline-block bg-red-600 text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer"
            >
              Subscribe to Newsletter
            </a>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSf1_pmDnir9wO6A_cDHBPNg4ezmbiIf5P8ar6Qac2uzqy-TYw/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-gray-900 px-8 py-4 rounded-lg text-base font-bold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
            >
              Join the Team
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
